import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Field, reduxForm, InjectedFormProps } from 'redux-form';
import { connect } from 'react-redux';
import LoaderButton from '../../../shared/components/Button/LoaderButton';
import { validateSelectICCIDRequired } from '../../../helpers/validation.helper';
import { FormattedMessage } from 'react-intl';
import ReduxFormSelect from '../../../shared/components/ReduxFormHandlers/ReduxFormSelect';
import ReduxFormTextArea from '../../../shared/components/ReduxFormHandlers/ReduxFormTextArea';
import "./DeviceStateForm.css";
interface IProps {
    submitHandler: (data: any) => void;
    onModalClosed: () => void;
}

const DeviceStateForm: React.FC<InjectedFormProps<any, IProps> & IProps> = (props: any) => {
    const submitHandler = (values:any) => {
        props.submitHandler(values);
    }
    return (
        <Modal className="add-user-modal device-pop-up" show={true} centered onHide={props.onModalClosed}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <FormattedMessage id='Device_State' />
                </Modal.Title>
            </Modal.Header>

            <form onSubmit={props.handleSubmit((values: any) => submitHandler(values))} noValidate>
                <Modal.Body>
                <div className="form-group row">
                            <label className="label-style"><FormattedMessage id='Sensor_Label_ICCID' /></label>
                            <Field
                                className="form-control"
                                name="ICCID"
                                component={ReduxFormSelect}
                                type="text"
                                options={[{"id":-1,value:"--select--"},
                                            {"id":"8988228066602489832",value:"8988228066602489832"},
                                            {"id":"8988228066602489844",value:"8988228066602489844"},
                                            {"id":"8988228066602489920",value:"8988228066602489920"}
                                        ]}
                                validate={[validateSelectICCIDRequired("Validation_Required_ICCID")]}
                            >
                            </Field>
                        </div>
                        <div className="send-button">
                            <div className="form-group row tab-action">
                                <div className="col-12 px-0">
                                    {/* <Button variant="primary" onClick={props.onModalClosed}><FormattedMessage id='Button_Cancel' /></Button> */}
                                    <LoaderButton type="submit" text="Button_Send" />
                                </div>
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="label-style"><FormattedMessage id='Received_Device_state' /></label>
                            <Field
                                className="form-control text-area"
                                name="recievedJSONText"
                                component={ReduxFormTextArea}
                                type="text"
                                readOnly={true}
                                // validate={[validateRequired("Validation_Required_JSON"),
                                //     validateValidJSONText("Sensor_Validation_Required_ValidJSON")]}
                                rows={6}
                            >
                            </Field>
                        </div>
                       
                </Modal.Body>

                <div className="modal-footer">
                    <div className="form-group row tab-action">
                        <div className="col-12 px-0">
                            <Button variant="primary" onClick={props.onModalClosed}><FormattedMessage id='Button_Cancel' /></Button>
                            {/* <LoaderButton type="submit" text="Button_Send" /> */}
                        </div>
                    </div>
                </div>
            </form>

        </Modal>
    )
}


const mapStateToProps = () => ({

});


const form = reduxForm<any, IProps>({
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: false,
    form: 'DeviceStateForm',
    enableReinitialize: true,
    onSubmitFail: (errors: any) => {
        // toast.error(formatMessage('Validation_Correct_error'));
    }
})(DeviceStateForm);


export default connect(mapStateToProps)(form);
